import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import dashboardReducer from "../features/dashboard/dashboardSlice";
import logoutReducer from "../features/logout/logoutSlice";
import configureReducer from "../features/configurable/configurableSlice";
import clientProcessReducer from "../features/clientProcess/clientProcessSlice";
import structureClientFormReducer from "../features/structureClientForm/structureClientFormSlice";
import ocrReducer from "../features/OCR/OCRSlice";
import documentaryValidationReducer from "../features/documentaryValidation/documentaryValidationSlice";
import identityReducer from "../features/identity/identitySlice";
import { dash } from "features/dashboardMySelf/dashAPI";
import { microserviceApi } from "features/dashboardMySelf/microserviceApi";
import { microserviceFinalizeApi } from "features/Finalize/microserviceFinalizeAPI";
import { finalize } from "features/Finalize/FinalizeAPI";
import { microServiceIdentityAPI } from "features/identityMutation/microServiceIdentityAPI";
import { microServiceStructureAPI } from "features/structureMutation/microServiceStructureAPI";
import { microServiceBeMyselfAPI } from "features/bemyselfMutation/microServicebemyselfMutationAPI";
import { microserviceDocReviewAPI } from "features/docReview/microserviceDocReviewAPI";
import { docReview } from "features/docReview/docReview";
import { microserviceClientProcessAPI, microserviceClientProcessAPIWithoutAuth } from "features/clientProcessMutation/microserviceClientProcessAPI";
import { microServiceOcrAPI } from "features/ocrMutation/microServiceOcrAPI";
import { clientProcess } from "features/clientProcessMutation/clientProcess";
import filterReducer from "features/dashboardMySelf/filterSlice";
import configurationReducer from "features/dashboardMySelf/configurableSlice";
import { microServiceAuthApi } from "features/authRTK/microServiceAuthApi";
import { microServiceApiWithTokenRevoke } from "features/dashboardMySelf/microserviceApi";
import { microServiceIdentityAPIWithTokenRevocation } from "features/identityMutation/microServiceIdentityAPI";
import { microServiceClientProcessRevokeAPI } from "features/clientProcessMutation/microserviceClientProcessAPI";
import { microServiceSecurityApi } from "features/security/microServiceSecurityApi";
import { microServiceRequestManager } from "features/requestManager/microServiceRequestManager";
import { microServiceLicenseMutation } from "features/licenseMutation/microServiceLicenseMutation";
import { microServiceBioManagerMutation } from "features/bioManager/microServiceBioManagerMutation";
import { microServiceLicenseOriginMutation } from "features/licenseMutation/microServiceLicenseOriginMutation";
export const store = configureStore({
  reducer: {
    auth: authReducer,
    dashboard: dashboardReducer,
    logout: logoutReducer,
    configurable: configureReducer,
    clientProcess: clientProcessReducer,
    structureClientForm: structureClientFormReducer,
    ocr: ocrReducer,
    identity: identityReducer,
    documentaryValidation: documentaryValidationReducer,
    filters: filterReducer,
    configuration: configurationReducer,
    [microserviceApi.reducerPath]: microserviceApi.reducer,
    [dash.reducerPath]: dash.reducer,
    [microserviceFinalizeApi.reducerPath]: microserviceFinalizeApi.reducer,
    [finalize.reducerPath]: finalize.reducer,
    [microServiceIdentityAPI.reducerPath]: microServiceIdentityAPI.reducer,
    [microServiceStructureAPI.reducerPath]: microServiceStructureAPI.reducer,
    [microServiceBeMyselfAPI.reducerPath]: microServiceBeMyselfAPI.reducer,
    [microserviceDocReviewAPI.reducerPath]: microserviceDocReviewAPI.reducer,
    [docReview.reducerPath]: docReview.reducer,
    [microserviceClientProcessAPI.reducerPath]: microserviceClientProcessAPI.reducer,
    [microserviceClientProcessAPIWithoutAuth.reducerPath]: microserviceClientProcessAPIWithoutAuth.reducer,
    [clientProcess.reducerPath]: clientProcess.reducer,
    [microServiceOcrAPI.reducerPath]: microServiceOcrAPI.reducer,
    [microServiceAuthApi.reducerPath]:microServiceAuthApi.reducer,
    [microServiceApiWithTokenRevoke.reducerPath]: microServiceApiWithTokenRevoke.reducer,
    [microServiceIdentityAPIWithTokenRevocation.reducerPath]: microServiceIdentityAPIWithTokenRevocation.reducer,
    [microServiceClientProcessRevokeAPI.reducerPath]: microServiceClientProcessRevokeAPI.reducer,
    [microServiceSecurityApi.reducerPath]: microServiceSecurityApi.reducer,
    [microServiceRequestManager.reducerPath]: microServiceRequestManager.reducer,
    [microServiceLicenseMutation.reducerPath]: microServiceLicenseMutation.reducer,
    [microServiceBioManagerMutation.reducerPath]: microServiceBioManagerMutation.reducer,
    [microServiceLicenseOriginMutation.reducerPath]: microServiceLicenseOriginMutation.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(
      microserviceApi.middleware, dash.middleware,
      microserviceFinalizeApi.middleware, finalize.middleware,
      microServiceIdentityAPI.middleware,
      microServiceStructureAPI.middleware,
      microServiceBeMyselfAPI.middleware,
      microserviceDocReviewAPI.middleware, docReview.middleware,
      microserviceClientProcessAPI.middleware, microserviceClientProcessAPIWithoutAuth.middleware,
      microServiceApiWithTokenRevoke.middleware,
      clientProcess.withAuth.middleware, clientProcess.withoutAuth.middleware,
      microServiceOcrAPI.middleware,  microServiceAuthApi.middleware,
      microServiceIdentityAPIWithTokenRevocation.middleware,
      microServiceClientProcessRevokeAPI.middleware,
      microServiceSecurityApi.middleware,
      microServiceRequestManager.middleware,
      microServiceLicenseMutation.middleware,
      microServiceBioManagerMutation.middleware,
      microServiceLicenseOriginMutation.middleware,
    ),
});
